import { caching } from '@/common/cache.dict.js';
import { logSearch } from '@/restapi/logs.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/product/');


/* Поиск */
export async function findProducts(query = '', exclude = null) {
    const { result } = await doRequest('findProducts', {
        limit: 12,
        query,
        exclude,
    });

    return result;
}

export async function suggest(query = '') {
    const { result } = await doRequest('suggest', {
        query,
        limit: 12,
    });
    return result;
}

export async function searchProducts(reqt) {
    const { result } = await doRequest('search', reqt, { messages: false });
    return result;
}

export async function fullSearchProducts(reqt, logging = false) {
    const startTime = Date.now();

    const { result } = await doRequest('fullSearch', reqt, { messages: false });

    if (logging)
        logSearch({ ...reqt.params }, Date.now() - startTime);

    return result;
}

export async function partialSearchProducts(reqt) {
    const { result } = await doRequest('partSearch', reqt, { messages: false });
    return result;
}


/* Получение продукта */
export async function loadBasicInfo(id) {
    const { result } = await doRequest('loadBasic', { id });
    return result;
}

export async function loadProducts(ids) {
    if (!ids || !ids.length) {
        return [];
    }

    const { result } = await doRequest('loadList', { ids });
    return result;
}

export async function loadProduct(id) {
    const { result } = await doRequest('load', { id });
    return result;
}

/* Обновление */
export async function publication(id) {
    const { result } = await doRequest('publish', { id }, {
        blocking: true,
    });
    return result;
}

export async function saveProduct(reqt) {
    const { result } = await doRequest('save', reqt, {
        messages: false,
        blocking: true,
    });
    return result;
}

export async function deleteProduct(id) {
    const { result } = await doRequest('delete', { id });
    return result;
}


/* Обновление связей */
export async function updatePilots(reqt) {
    await doRequest('update/pilots', reqt, { blocking: true });
}

export async function updateContacts(reqt) {
    await doRequest('update/contacts', reqt);
}

export async function updateDocuments(reqt) {
    await doRequest('update/documents', reqt);
}

export async function updateRelations(reqt) {
    await doRequest('update/relations', reqt);
}

export async function updateBackground(reqt) {
    await doRequest('update/background', reqt);
}

export async function archiveProduct(reqt) {
    const { result } = await doRequest('update/archiveState', reqt);
    return result;
}


/* Остальные */
async function _loadDicts() {
    const { result } = await doRequest('dicts');
    return result;
}

export const loadDicts = caching(_loadDicts);

export async function productCount() {
    const { result } = await doRequest('count');
    return result;
}
